import * as React from "react";
import {Fragment} from "react";
import {RouteComponentProps, withRouter} from "react-router";
import WorkspaceContainer, {WorkspaceName} from "../table/workspace/WorkspaceContainer";
import Routes from "../../../navigation/route/Route";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import {option} from "ts-option";
import SortColumnModel from "../../../model/workspace/SortColumnModel";
import {WildcardFilterColumnType} from "../../../model/workspace/WildcardFilter";
import {RootState} from "../../../store/reducer/root/RootState";
import {connect} from "react-redux";
import ButtonGroupWrapper from "../../../hiberUiKit/src/atoms/Buttons/ButtonGroupWrapper";
import {api} from "../../../api/api";
import UploadPartnerBrandModal from "../../admin/partnerBrands/modal/UploadPartnerBrandModal";
import {notifyBugsnagAndShowToast} from "../../../utils/Utils";

interface IState {
	/**
	 * Indicates if upload modal is visible
	 */
	uploadModalVisible: boolean,
}

interface ReduxProps {
	/**
	 * Indicates if the user has the option of importing/exporting
	 */
	importExportEnabled: boolean
}

type Props = ReduxProps & RouteComponentProps<any>

const defaultSort = option(new SortColumnModel("1d2d01bf-7f6d-4b7e-b5b0-0f58eeebefbb", "name", true));

class PartnerBrandWorkspaceContainer extends React.PureComponent<Props, IState> {
	refs: {
		WorkspaceContainer: any
	};

	constructor(props: Props) {
		super(props);

		this.state = {uploadModalVisible: false};

		this.openUploadPartnerBrandsModal = this.openUploadPartnerBrandsModal.bind(this);
		this.onPartnerBrandsUploadSuccess = this.onPartnerBrandsUploadSuccess.bind(this);
		this.closeUploadPartnerBrandsModal = this.closeUploadPartnerBrandsModal.bind(this);
	}

	render() {
		return (
			<>
				<WorkspaceContainer ref={"WorkspaceContainer"}
									workspaceName={WorkspaceName.PartnerBrands}
									wildcardFilterColumnType={WildcardFilterColumnType.PartnerBrands}
									onRowClick={(rowId: string) => this.props.history.push(Routes.PartnerBrandEdit(rowId))}
									rowToId={(row) => row.id}
									renderButton={this.renderActionBtn}
									sortable
									defaultSort={defaultSort}
				/>
				{this.state.uploadModalVisible &&
				<UploadPartnerBrandModal onSuccess={this.onPartnerBrandsUploadSuccess}
										 onCancel={this.closeUploadPartnerBrandsModal}/>}
			</>
		)
	}

	renderActionBtn = () => {
		return (
			<ButtonGroupWrapper>
				<ButtonPrimary onClick={this.goToPartnerBrandCreation}
							   label={"Create Partner Brand"}
							   variant={"burgundy"}/>
				{this.props.importExportEnabled && <Fragment>
					<ButtonPrimary onClick={this.downloadPartnerBrandsXlsx}
								   label={"Download Partner Brands"}
								   variant={"burgundy"}/>
					<ButtonPrimary onClick={this.openUploadPartnerBrandsModal}
								   label={"Upload Partner Brands"}
								   variant={"burgundy"}/>
				</Fragment>}
			</ButtonGroupWrapper>
		)
	};

	goToPartnerBrandCreation = () => {
		this.props.history.push(Routes.PartnerBrandCreate);
	};

	/**
	 * Download partner brands.
	 */
	downloadPartnerBrandsXlsx() {
		api.instance.partnerBrandApi.downloadPartnerBrands().catch(
			(err) => {
				let errorMsg;
				if (err && err.response && err.response.status == 409
					&& err.response.data.exception == "DuplicatedCustomFieldLabelsException") {
					errorMsg = "Cannot export because there is more than 1 custom field with the same label"
				}
				notifyBugsnagAndShowToast(err, "Partner brands download", errorMsg);
			})
	}

	/**
	 * Open upload modal
	 */
	openUploadPartnerBrandsModal() {
		this.setState({uploadModalVisible: true});
	}

	/**
	 * Actions after partner brands upload
	 */
	onPartnerBrandsUploadSuccess() {
		if (this.refs.WorkspaceContainer) {
			this.refs.WorkspaceContainer.refreshData();
		}
		this.closeUploadPartnerBrandsModal();
	}

	/**
	 * Close upload modal
	 */
	closeUploadPartnerBrandsModal() {
		this.setState({uploadModalVisible: false});
	}

}

function mapStateToProps(state: RootState) {
	return {
		importExportEnabled: state.user.user.map(user =>
			!user.isBusinessDevelopmentPartner() || user.isAdmin()).getOrElse(false)
	}
}

export default withRouter(connect(mapStateToProps)(PartnerBrandWorkspaceContainer));
